import {Button, Row, Table} from "antd";
import {pharmacyStoreService} from "api";
import TableCustom from "components/common/TableCustom/TableCustom";
import React, {useEffect, useState} from "react";
import {columns} from "./config";
const BidDeadline = props => {
  const [params, setParams] = useState({page: 1, limit: 15});
  const [data, setData] = useState<any>();
  const getData = async params => {
    try {
      const res = await pharmacyStoreService.getListMedicineByAllParams({
        ...params,
        isSearchThau: true,
      });
      console.log(res);
      setData(res?.data);
    } catch (error) {}
  };
  useEffect(() => {
    getData(params);
  }, [params]);
  return (
    <div className="">
      <div className="">
        <div className="container">
          <Row justify="end">
            <Button
              type="primary"
              onClick={() => {
                getData(params);
              }}
            >
              Cập nhật
            </Button>
          </Row>
          <TableCustom
            dataSource={data}
            columns={columns}
            pagination={false}
          ></TableCustom>
        </div>
      </div>
    </div>
  );
};
export default BidDeadline;
